
export enum NotificationCategory {
    Assignments = 'Assignments',
    StatusChanges = 'StatusChanges',
    Comments = 'Comments',
    Reminders = 'Reminders',
    Security = 'Security',
    Integrations = 'Integrations',
    AI = 'AI',
    Connect = 'Connect',
    BulkActions = 'BulkActions',
}
